import { useMsal } from "@azure/msal-react";
import { Routes, Route, useLocation} from "react-router-dom";
import AuthenticatedApp from "./Components/AuthenticatedApp.jsx";
import InviteFormPage from "./Pages/InviteFormPage.jsx";
import { AnimatePresence, LayoutGroup } from "framer-motion";
import SubmissionSuccess from "./Pages/SubmissionSuccess.jsx";
import { UpdateToast } from "./utils/helpers.js";
import { loginRequest } from "./auth.js";


const App = () => {
  const { accounts, instance } = useMsal();
  const location = useLocation();

  // Just grab the first account (MSAL supports multi-account but you likely only need one)
  const user = accounts[0] || null;

  console.log("Current path:", window.location.pathname, window.location.search);
  console.log("Current user:", user?.username);


  return (
    <LayoutGroup>
      <AnimatePresence>
        <Routes location={location} key={location.pathname}>
          <Route path="/invite" element={<InviteFormPage />} />
          <Route path="/submission-success" element={<SubmissionSuccess />} />
          <Route path="/*" element={
            <AuthenticatedApp
              user={user}
              onLogin={() => instance.loginRedirect(loginRequest)}
              onLogout={() => instance.logoutRedirect()}
              location={location}
            />
          } />
        </Routes>
      </AnimatePresence>
      <UpdateToast />
    </LayoutGroup>
  );
};

export default App;
